import { InlineTreeSelect } from '../components/InlineTreeSelect'
import { useProjectPlanSelectOptions } from './hooks/useProjectPlanSelectOptions'

type Props = {
  snapshotUuid: string
  value: string[]
  onChange: (value: string[]) => void
  multiSelect?: boolean
  height?: string
}

export const ProcessTreeSelect = ({
  snapshotUuid,
  value,
  onChange,
  multiSelect = true,
  height,
}: Props) => {
  const { options, parentMap } = useProjectPlanSelectOptions({
    snapshotUuid,
    selectedUuids: value,
  })

  return (
    <InlineTreeSelect
      options={options}
      parentMap={parentMap}
      value={value}
      onChange={onChange}
      multiSelect={multiSelect}
      height={height}
    />
  )
}
